export default __webpack_public_path__ + "static/media/logoBuysilia.8cc93c84.png";